export default __webpack_public_path__ + "static/salon-deals-car-pointer-horizontal~bldBnfTn-55054c85e05069765b0123e0e5ffa909.png";